import { useQuery } from "react-query";
import { getClientInsurancesAsync } from "api/insurance";
import { ClientInsurance } from "api/types/insurance";
import { GET_CLIENT_INSURANCES, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";

const createdTime = (ins: ClientInsurance): number =>
  ins?.created ? new Date(ins.created).getTime() : 0;

// Stopgap: matches Kaiser by company-name substring; to be replaced by the insurance rules engine.
export function isPrimaryInsuranceKaiser(
  insurances: ClientInsurance[] | null | undefined
): boolean {
  if (!Array.isArray(insurances)) return false;
  const primary = insurances
    .filter((ins) => Boolean(ins?.is_primary) && Boolean(ins?.active))
    .sort((a, b) => createdTime(b) - createdTime(a))[0];
  return Boolean(primary?.insurance_name?.toLowerCase().includes("kaiser"));
}

export default function useIsClientKaiserPrimary(clientId: string | number | null | undefined) {
  const { data, isLoading } = useQuery({
    queryKey: [GET_CLIENT_INSURANCES, clientId],
    queryFn: () => getClientInsurancesAsync(clientId!),
    enabled: !!clientId,
    staleTime: STALE_TIME_5_MINUTES,
  });

  const insurances: ClientInsurance[] = data?.data ?? [];
  return {
    isKaiserPrimary: isPrimaryInsuranceKaiser(insurances),
    isLoading,
  };
}
